'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { useGeneratedId } from '../../hooks/useGeneratedId.js';
import { Label } from '../Label/Label.js';
import { List } from '../List/List.js';
import { ListItem } from '../List/ListItem.js';
import '../Radio/Radio.js';
import '../Radio/RadioGroup.js';
import { RadioGroupProvider } from '../Radio/RadioGroupProvider.js';
import '../Radio/RadioProvider.js';
import { Text } from '../Text/Text.js';
import { Tile } from './Tile.js';

const ErrorText = styled(Text).withConfig({
  componentId: "sc-p9d9fe-0"
})(["margin:", ";"], ({
  theme
}) => theme.components.input.errorTextMargin);
const TileGroup = /*#__PURE__*/withTitan(({
  name,
  label,
  labelTooltip,
  options,
  value,
  defaultValue = '',
  variant = 'horizontal-start',
  spaceAfter,
  spaceBetween = 2,
  hasError,
  errorText,
  onChange,
  testId = 'tileGroup'
}) => {
  const errorId = useGeneratedId(undefined, 'tile-group-error');
  return jsxs(RadioGroupProvider, {
    defaultValue: defaultValue,
    name: name,
    value: value,
    onChange: onChange,
    children: [label && jsx(Label, {
      labelAs: "span",
      spaceAfter: 2,
      testId: `${testId}Label`,
      tooltip: labelTooltip,
      children: label
    }), jsx(List, {
      spaceAfter: spaceAfter,
      spaceBetween: spaceBetween,
      testId: `${testId}List`,
      variant: variant,
      children: options.map(option => jsx(ListItem, {
        children: jsx(Tile, Object.assign({
          hasError: hasError,
          testId: `${testId}Tile`
        }, hasError && errorText ? {
          'aria-invalid': true,
          'aria-describedby': errorId
        } : {}, option))
      }, option.value))
    }), errorText && hasError && jsx(ErrorText, {
      color: "danger50",
      "data-test-id": `${testId}ErrorMessage`,
      id: errorId,
      type: "labelTiny",
      children: errorText
    })]
  });
}, {
  name: 'TileGroup'
});

export { TileGroup };
//# sourceMappingURL=TileGroup.js.map
